<template>
<div class="filter-body" >
    <div class="form-group">
        <label for=""> Sent Status</label>
        <div class="form-check" v-for="(filter,index) in sentStatusFilters">
            <label class="form-check-label"><input checked="" class="form-check-input" name="retouch_sent_status" type="radio" :value="filter.key" :checked="index === 0" >{{filter.name}}</label>
        </div>
    </div>
    <div class="form-group">
        <label for=""> Received Status</label>
        <div class="form-check" v-for="(filter,index) in receivedStatusFilters">
            <label class="form-check-label"><input checked="" class="form-check-input" name="retouch_received_status" type="radio" :value="filter.key" :checked="index === 0" >{{filter.name}}</label>
        </div>
    </div>
</div>
</template>

<script>
export default {
  data: function () {
    return {
      sentStatusFilters: [
        { 'name': 'All', 'key': '' },
        { 'name': 'Sent', 'key': 'Complete' },
        { 'name': 'Not Sent', 'key': 'Incomplete' }
      ],
      receivedStatusFilters: [
        { 'name': 'All', 'key': '' },
        { 'name': 'Received', 'key': 'Complete' },
        { 'name': 'Pending', 'key': 'Incomplete' },
        { 'name': 'Not Received', 'key': 'Not_Received' }
      ]
    }
  },
  mounted: function () {
    $('.select2').select2()
  }
}
</script>
